import { useAppDispatch } from "hooks/hooks";
import NewBuildingPopover from "./NewBuildingPopover";
import {
  getBuildingsList,
  selectState,
  setNewBuildingPopover,
  setNewSalesUnitPopover,
  setSearchHRSPopover
} from "../main.slice";
import NewSalesUnitPopover from "./NewSalesUnitPopover";
import { useNavigate } from "react-router-dom";
import ToolboxButton, { ToolboxButtonIcon } from "Dashboard/components/Buttons/ToolboxButton";
import Popover from "components/Popover/Popover";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { IBuildingCreate } from "Dashboard/scenes/HighRiseSales/domain/IBuildingCreate";
import { useState } from "react";
import { IOption } from "Dashboard/domain/IOption";
import { areQueryParamsEmpty } from "utils/queryParamsUtil";
import { SearchType } from "Dashboard/domain/SearchType";
import { IGetBuildingsListRequestParams } from "Dashboard/scenes/HighRiseSales/domain/IGetBuildingsListRequestParams";
import SearchHighRiseSalesPopover from "./SearchHighRiseSalesPopover";

const Toolbox = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { newBuildingPopover, newSalesUnitPopover, searchPopover }
    = useSelector(selectState);

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
  } = useForm<IBuildingCreate>();
  const [investorValue, setInvestorValue] = useState<IOption | undefined>(
    undefined
  );
  const [municipalityValue, setMunicipalityValue] = useState<IOption | undefined>(
    undefined
  );

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    setFocus: setFocusSearch,
    getValues: getValuesSearch,
    setValue: setValueSearch
  } = useForm<IGetBuildingsListRequestParams>();
  const [searchType, setSearchType] = useState<SearchType>(SearchType.BASIC);

  const isSearchFormEmpty = areQueryParamsEmpty(getValuesSearch());

  return (
    <>
      <nav>
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Back}
            tooltip="Glavni meni"
            toolbox={true}
            onClick={() => navigate('/dashboard')}
          />
        </div>
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Add}
            toolbox={true}
            onClick={() => dispatch(setNewBuildingPopover({ isOpen: true }))}
          />
          <ToolboxButton
            icon={ToolboxButtonIcon.Search}
            toolbox={true}
            onClick={() => {
              dispatch(setSearchHRSPopover({ isOpen: true }))
            }}
          />
          {!isSearchFormEmpty
            && (<ToolboxButton
              icon={ToolboxButtonIcon.CancelSearch}
              tiny={true}
              tooltip="Pokaži sve"
              onClick={() => {
                dispatch(getBuildingsList({}));
                resetSearch();
              }}
            />)}
          <ToolboxButton
            icon={ToolboxButtonIcon.Print}
            toolbox={true}
          />
        </div>
      </nav>
      <Popover
        isOpen={newBuildingPopover.isOpen}
        onClose={() => dispatch(setNewBuildingPopover({ isOpen: false }))}
        title="Nova gradnja"
        direction="right"
        arrowStyle={{ top: "40px" }}
        position={{ top: 10, left: 185 }}
      >
        <NewBuildingPopover
          handleSubmit={handleSubmit}
          register={register}
          control={control}
          errors={errors}
          reset={reset}
          investorValue={investorValue}
          setInvestorValue={setInvestorValue}
          municipalityValue={municipalityValue}
          setMunicipalityValue={setMunicipalityValue}
        />
      </Popover>
      <Popover
        isOpen={newSalesUnitPopover.isOpen}
        onClose={() => {
          dispatch(setNewSalesUnitPopover({ isOpen: false }))
        }}
        direction="right"
        title="Nova prodajna jedinica"
        arrowStyle={{ top: "40%" }}
        position={{
          top: newSalesUnitPopover.top,
          left: newSalesUnitPopover.left,
          offsetLeft: 22,
          offsetTop: -65
        }}
      >
        <NewSalesUnitPopover />
      </Popover>
      <Popover
        isOpen={searchPopover.isOpen}
        onClose={() => {
          dispatch(setSearchHRSPopover({ isOpen: false }));
        }}
        direction="right"
        arrowStyle={{ top: "40px" }}
        title="Pretraga"
        position={{ top: 10, left: 250 }}
      >
        <SearchHighRiseSalesPopover
          handleSubmit={handleSubmitSearch}
          register={registerSearch}
          control={controlSearch}
          getValues={getValuesSearch}
          setValue={setValueSearch}
          searchType={searchType}
          setSearchType={setSearchType}
          setFocus={setFocusSearch}
        />
      </Popover>
    </>
  );
};

export default Toolbox;
